module.exports = __webpack_public_path__ + "img/thumbnail_MalabarRose_u_normal.a636064a.png";